import React from 'react';
import {Col, Row} from "reactstrap";
import MomentDisplay from "../../../../commonComponents/momentDisplay";
import moment from "moment";


export default function ExpandedTransactionDetail({data}) {
    return (
        <>
            <Row>
                <Col sm={2} className="text-end small text-black-50">Email</Col>
                <Col sm={10}>{data.email}</Col>
            </Row>
            <Row>
                <Col sm={2} className="text-end small text-black-50">Mobile</Col>
                <Col sm={10}>{data.mobile}</Col>
            </Row>
            <Row>
                <Col sm={2} className="text-end small text-black-50">Name</Col>
                <Col sm={10}>{data.first_name} {data.last_name}</Col>
            </Row>

            <Row>
                <Col sm={2} className="text-end small text-black-50">Purpose</Col>
                <Col sm={10}>{data.purpose}</Col>

            </Row>
            <Row>
                <Col sm={2} className="text-end small text-black-50">Last Updated</Col>
                <Col sm={10} className="small">
                    <MomentDisplay momentData={moment(data.updated_at)}/>
                </Col>
            </Row>
        </>
    )
}